import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import ContractorForm from "./contractorComponents/ContractorForm";

import { useAddContractorMutation } from "store/services/contractorApi";

import { useAppMeta } from "hooks";

const ContractorCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Contractor Profiles", path: "/app/crm/contractor/list" },
    { title: "New Contractor Profile" },
  ];

  const [createContractor, { isLoading: creatingContractor }] = useAddContractorMutation();

  const handleCreateContractor = async (data) => {
    try {
      const { contractor } = await createContractor(data).unwrap();
      
      toast.success("Contractor successfully created!");
      navigate(`/app/crm/contractor/${contractor._id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create Contractor!");
    }
  };

  useAppMeta("New Contractor");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingContractor}>
      <BreadcrumbLayout.Paper>
        <ContractorForm isBusy={creatingContractor} onSubmit={handleCreateContractor} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ContractorCreateScreen;
